module.exports = __webpack_public_path__ + "static/media/organicos.88b8ff67.png";